import { createAction, props } from '@ngrx/store';
import { Variables } from '../package.models';

export const updateVariables = createAction(
  '[PackageDesigner] Update variables',
  props<{ variables: Variables; secretVariables?: Variables; secretVariablesToUpdate?: Variables }>(),
);
export const addVariable = createAction('[PackageDesigner] Add variable', props<{ variables: Variables }>());
export const removeVariable = createAction('[PackageDesigner] Remove variable', props<{ variableName: string }>());
